// extracted by mini-css-extract-plugin
module.exports = {"link":"NavLink_link__1-WM9","text":"NavLink_text__3gsQw","button":"NavLink_button__3M2YP","dropdownText":"NavLink_dropdownText__rH6SI"};